import * as React from 'react';

import { DropdownField } from '../../../components/dropdownField';
import { EWCCount, EWCType } from '../../../../../../../json_query';

interface IBathroomProps {
  wcType: EWCType;
  wcCount: EWCCount;

  onWCTypeChanged(wcType: EWCType, wcCount: EWCCount): void;
  onWCCountChanged(wcType: EWCType, wcCount: EWCCount): void;
}

export enum EBathroom {
  Any = 'any',
  United = 'united',
  Separated = 'separated',
  Multiple = 'multiple',
}

const VALUES: { label: string; value: EBathroom }[] = [
  { label: 'Любой', value: EBathroom.Any },
  { label: 'Совмещенный', value: EBathroom.United },
  { label: 'Раздельный', value: EBathroom.Separated },
  { label: '2 и более', value: EBathroom.Multiple },
];

export class Bathroom extends React.Component<IBathroomProps> {
  public render() {
    return <DropdownField value={this.getUrbanValue()} onValueChange={this.handleUrbanChange} values={VALUES} />;
  }

  private getUrbanValue = (): EBathroom => {
    const { wcType, wcCount } = this.props;

    if (wcCount !== EWCCount.Any && wcCount !== EWCCount.One) {
      return EBathroom.Multiple;
    }

    if (wcType === EWCType.United) {
      return EBathroom.United;
    }

    if (wcType === EWCType.Separated) {
      return EBathroom.Separated;
    }

    return EBathroom.Any;
  };

  private handleUrbanChange = (value: EBathroom) => {
    const { onWCTypeChanged, onWCCountChanged } = this.props;

    switch (value) {
      case EBathroom.United:
        onWCTypeChanged(EWCType.United, EWCCount.Any);
        onWCCountChanged(EWCType.United, EWCCount.Any);
        break;

      case EBathroom.Separated:
        onWCTypeChanged(EWCType.Separated, EWCCount.Any);
        onWCCountChanged(EWCType.Separated, EWCCount.Any);
        break;

      case EBathroom.Multiple:
        onWCTypeChanged(EWCType.Any, EWCCount.Two);
        onWCCountChanged(EWCType.Any, EWCCount.Two);
        break;

      default:
        onWCTypeChanged(EWCType.Any, EWCCount.Any);
        onWCCountChanged(EWCType.Any, EWCCount.Any);
    }
  };
}
